import { Grid, useMediaQuery } from "@mui/material";
import { BooleanField, DateField, Labeled, ReferenceField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { SectionTitle } from "features/SectionTitle";

const MobilitySection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Мобилност"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Статус">
            <ReferenceField
              source="userInfo.status"
              reference={erasmusRequests.getStatusesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Университет">
            <ReferenceField
              source="userInfo.universityId"
              reference={administrationRequests.getUniversitiesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="BIP">
            <BooleanField source="userInfo.isBip" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Начало на обучението">
            <DateField
              locales="bg-BG"
              source="userInfo.startDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Край на обучението">
            <DateField
              locales="bg-BG"
              source="userInfo.endDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Дата на пристигане">
            <DateField
              locales="bg-BG"
              source="userInfo.arrivalDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Дата на заминаване">
            <DateField
              locales="bg-BG"
              source="userInfo.departureDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Координатор - име">
            <TextField
              source="userInfo.coordinatorName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Координатор - имейл">
            <TextField
              source="userInfo.coordinatorEmail"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Желае общежитие">
            <BooleanField source="userInfo.wantsDormitory" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Labeled label="Мотивационно писмо">
            <TextField
              source="userInfo.shortMotivationLetter"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default MobilitySection;
